import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 招标采购路由生成函数
 * @param modulePath
 * @param prefix
 * @param sideMenuTitle
 * @param applicableCompanyIdentities
 * @param roles
 * @param listRoute
 * @param needIcon
 * @returns <Object> route
 */
export default function generateBiddingRoutes(
  modulePath = 'bidding',
  prefix = '',
  sideMenuTitle = '招标采购',
  applicableCompanyIdentities = [workbenchServiceDict.PURCHASER.value],
  roles = [platformFunctionModuleDict.PURCHASER.right],
  listRoute = {},
  needIcon = true
) {
  return {
    path: modulePath,
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: sideMenuTitle,
      icon: needIcon ? 'icon-side_purchase_bid' : '',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities,
    roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
    superviseInstitutions: [],

    children: [
      // 项目列表
      Object.assign(
        {},
        {
          path: 'list',
          name: `${prefix}BiddingList`,
          component: '/procure-views/purchase/invite-bid/invite-bid-list/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '项目列表',
            cache: true,
            hidden: true,
            pageComponentName: 'BiddingList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities,
          roles: [
            ...roles,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        listRoute
      ),

      // 发布招标
      {
        path:
          'orders/:orderId?/projects/:projectId?/edit/:isCopy?/kpbFile/:kpbFileId?/:isAuction?',
        name: `${prefix}BiddingForm`,
        component: '/procure-views/purchase/invite-bid/invite-bid-form/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '发布招标',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 电子化全流程
      {
        path: 'kpb-project',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '电子化全流程',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: [],

        children: [
          // 标书制作
          {
            path:
              'bid-order/:orderId?/entrust/:projectId?/file/:kpbFileId/last/:lastKpbFileId?/form/:lastRoute?',
            name: `${prefix}KpbBidFileForm`,
            component:
              '/procure-views/purchase/invite-bid/invite-bid-form/bid-file-form',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '标书制作',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 招标文件详情
          {
            path: ':biddingFileId/detail',
            name: `${prefix}KpbBidFileDetail`,
            component:
              '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '招标文件详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 开标大厅 - 倒计时
          {
            path: ':projectId/open-hall/door',
            name: `${prefix}BidOpenHallDoor`,
            component: '/hall/bid-open-hall/bid-open-hall-door',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '开标大厅（倒计时）',
              layout: 'BidOpenHallLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              {
                companyType: companyTypeDict.ENTERPRISE.value,
                menuName: '开标大厅'
              },
              {
                companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
                menuName: '开标大厅'
              }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 开标大厅
          {
            path: ':projectId/open-hall/home',
            name: `${prefix}BidOpenHallHome`,
            component: '/hall/bid-open-hall/bid-open-hall-home',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '开标大厅',
              layout: 'BidOpenHallLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 组长推荐
          {
            path: ':projectId/review-hall/leader-recommend',
            name: `${prefix}LeaderRecommend`,
            component: '/hall/review-hall/leader-recommend',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '组长推荐',
              layout: 'ReviewHallLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 专家评审
          {
            path: ':projectId/review-hall/review-session/:wayId?/:wayType?',
            name: `${prefix}ReviewSession`,
            component: '/hall/review-hall/review-session',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '专家评审',
              layout: 'ReviewHallLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 评标报告
          {
            path: ':projectId/review-hall/review-report',
            name: `${prefix}ReviewReport`,
            component: '/hall/review-hall/review-report',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '评标报告',
              layout: 'ReviewHallLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 评审报告一阶段
          {
            path: ':projectId/review-hall/review-report/first-stage',
            name: `${prefix}ReviewReportFirst`,
            component: '/hall/review-hall/review-report-first',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '一阶段评标报告',
              layout: 'ReviewHallLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 招标文件
          {
            path: ':projectId/bidding-file/:attachmentIds',
            name: `${prefix}BiddingFilePreview`,
            component: '/hall/review-hall/bidding-file-preview',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '招标文件',
              layout: 'NoLayout',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      },

      // 发布预览
      {
        path:
          'orders/:orderId/projects/:projectId?/kpbFile/:kpbFileId?/preview',
        name: `${prefix}BiddingPreview`,
        component: '/procure-views/purchase/invite-bid/invite-bid-form/preview',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '发布预览',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 招标详情
      {
        path: 'orders/:orderId/info',
        name: `${prefix}BiddingInfo`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/info/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '招标详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 招标文件详情
      {
        path: 'orders/:orderId/bidding-file/:biddingFileId/:projectId?',
        name: `${prefix}BiddingFileInfo`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '招标文件详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报名情况
      {
        path: 'orders/:orderId/apply',
        name: `${prefix}BiddingApply`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/apply/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报名情况',
          cache: true,
          hidden: true,
          pageComponentName: 'BiddingApply'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报名审核
      {
        path:
          'orders/:orderId/apply/signups/:tradeId/suppliers/:supplierId/form',
        name: `${prefix}BiddingApplyReview`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/apply/apply-form',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报名审核',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报名审核结果
      {
        path:
          'orders/:orderId/apply/signups/:tradeId/suppliers/:supplierId/approval/:isApproval/detail',
        name: `${prefix}BiddingApplyReviewResult`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/apply/apply-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报名审核结果',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 开标情况
      {
        path: 'orders/:orderId/open',
        name: `${prefix}BiddingOpenStep`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/bid-open-step',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '开标情况',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 评标情况
      {
        path: 'orders/:orderId/review',
        name: `${prefix}BiddingReviewStep`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/bid-review-step',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '评标情况',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 确定中标候选人
      {
        path: 'orders/:orderId/:abnormal?/candidate',
        name: `${prefix}BiddingCandidate`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/candidate/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '确定中标候选人',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 中标候选人
      {
        path: 'orders/:orderId/candidate/detail',
        name: `${prefix}BiddingCandidateDetail`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/candidate/detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '中标候选人',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 候选人审批详情
      {
        path: 'orders/:orderId/candidate/audit/detail',
        name: `${prefix}BiddingCandidateNewest`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/candidate/candidate-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '候选人审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 中标结果通知
      {
        path: 'orders/:orderId/:abnormal?/winner',
        name: `${prefix}BiddingWinner`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/result/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '中标结果通知',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 中标结果
      {
        path: 'orders/:orderId/winner/detail',
        name: `${prefix}BiddingWinnerDetail`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/result/detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '中标结果',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 中标结果审批详情
      {
        path: 'orders/:orderId/winner/audit/detail',
        name: `${prefix}BiddingResultNewest`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/result/result-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '中标结果审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更公告
      {
        path: 'orders/:orderId/changes/content/:edit?',
        name: `${prefix}BiddingContentChanges`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/changes/content-changes',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更公告',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更审批详情
      {
        path: 'orders/:orderId/audit/changes/content',
        name: `${prefix}BiddingChangeNewestDetail`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/changes/change-detail-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 文件澄清
      {
        path:
          'orders/:orderId/changes/kpb-file/:kpbFileId?/change-file/:fileChangeGroupId?',
        name: `${prefix}BiddingFileChanges`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/changes/file-changes',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '文件澄清',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 澄清审批详情
      {
        path:
          'orders/:orderId/changes/kpb-file/:kpbFileId?/clarification/audit/:fileChangeGroupId?',
        name: `${prefix}BiddingNewestFileChanges`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/changes/file-changes-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '澄清审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标处理
      {
        path: 'orders/:orderId/abnormal/auction',
        name: `${prefix}BiddingAuction`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/abnormal/auction',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标处理',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标审批详情
      {
        path: 'orders/:orderId/abnormal/auction/audit',
        name: `${prefix}BiddingAuctionNewest`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/abnormal/auction-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 追加供应商
      {
        path: 'orders/:orderId/abnormal/add-supplier',
        name: `${prefix}BiddingAddSupplier`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/abnormal/add-supplier',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '追加供应商',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 保证金退款
      {
        path: 'orders/:orderId/bond/refund',
        name: `${prefix}BiddingBondRefund`,
        component:
          '/procure-views/purchase/invite-bid/invite-bid-detail/bond/refund',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '保证金退款',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      }
    ]
  }
}
